import { Component, Input, OnChanges, ChangeDetectionStrategy } from "@angular/core";
import { PhoneTextPart, splitPhoneNumbers } from "./phone-text";

/**
 * Free text with its phone numbers as tel: links, which open the operator's calling software
 * (as in the EMAAC phonebook). Line breaks follow the parent's white-space setting.
 */
@Component({
  selector: "app-phone-text",
  template: `@for (part of parts; track $index) {@if (part.phone) {<a [href]="'tel:' + part.phone" class="cursorPointerHover" data-testid="phone-text-link">{{ part.text }}</a>} @else {{{ part.text }}}}`,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class PhoneTextComponent implements OnChanges {
  @Input() text: string;
  parts: PhoneTextPart[] = [];

  ngOnChanges(): void {
    this.parts = splitPhoneNumbers(this.text);
  }
}
